import { DeliveryReportSortField } from "@saleor/deliveryReport/urls";
import { GetLmsReportCsCustomerQuery } from "@saleor/graphql";
import groupBy from "lodash/groupBy";
import orderBy from "lodash/orderBy";
import moment from "moment-timezone";

import { SortKeyFunction } from "../../types";

type DataItem = GetLmsReportCsCustomerQuery["getLmsReportCsCustomer"][0]["dataItem"][0];
type OrderTrackingOutput = Omit<
  GetLmsReportCsCustomerQuery["getLmsReportCsCustomer"][0],
  "__typename"
>;
export interface DataItemCommon extends DataItem, OrderTrackingOutput {}

export const getGroupKey = (
  item: DataItemCommon,
  itemList: DataItemCommon[]
) => {
  const hasParent = item.parentItemNo && item.dnNo;
  const hasMatchingParent = itemList.some(
    currentItem =>
      currentItem.deliveryItem === item.parentItemNo &&
      currentItem.dnNo === item.dnNo
  );

  return hasParent && hasMatchingParent
    ? `${item.parentItemNo}_${item.dnNo}`
    : "";
};

export const sortingItemList = (
  itemList: DataItemCommon[],
  field: DeliveryReportSortField,
  sortParam?:
    | { asc: boolean }
    | Partial<{ asc: boolean; sort: DeliveryReportSortField }>
) => {
  const sortKeys: Array<string | SortKeyFunction<DataItemCommon>> = [];

  if (field === "cutOffDate") {
    sortKeys.push(o => o[field] ?? "", "giTime");
  } else if (field === "planDelivery") {
    const dateFormats = ["DD-MM-YYYY HH:mm:ss", "YYYY-MM-DD"];
    sortKeys.push(o => {
      const parsedDates = dateFormats.map(format =>
        moment(o.planDelivery, format, true)
      );
      const validDate = parsedDates.find(date => date.isValid());
      return validDate ? validDate.toDate() : "";
    });
  } else {
    sortKeys.push(field);
  }

  if (field === "dnNo" || field === "billNo") {
    sortKeys.push("soNo", "itemNo");
  } else if (field === "soNo") {
    sortKeys.push("itemNo");
  }

  let sortingOrder;
  if (sortParam?.asc) {
    sortingOrder = "asc";
  } else {
    sortingOrder = "desc";
  }
  const sortOrderList = new Array(sortKeys.length).fill(sortingOrder);

  const groupListDataItem = groupBy(itemList, item =>
    getGroupKey(item, itemList)
  );

  const sortItemList = orderBy(
    groupListDataItem?.[""] || [],
    sortKeys,
    sortOrderList
  );
  delete groupListDataItem?.[""];

  for (const [key, value] of Object.entries(groupListDataItem)) {
    const [parentItemNo, dnNo] = key.split("_");
    const childList = orderBy(value, sortKeys, sortOrderList);
    const parentIndex =
      sortItemList.findIndex(
        item => item.deliveryItem === parentItemNo && item.dnNo === dnNo
      ) + (sortingOrder === "asc" ? 1 : 0);

    sortItemList.splice(parentIndex, 0, ...childList);
  }

  return sortItemList;
};
